var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1019 10.7593V10.7589H11.1046V6.88094C11.1046 4.98384 10.6962 3.52246 8.47833 3.52246C7.41215 3.52246 6.69666 4.10754 6.40456 4.66222H6.37372V3.69957H4.27087V10.7589H6.46052V7.26336C6.46052 6.343 6.63498 5.45305 7.77474 5.45305C8.89776 5.45305 8.9145 6.50337 8.9145 7.32239V10.7593H11.1019Z",
    fill: "#9597AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.705414 3.69995H2.8977V10.7592H0.705414V3.69995Z",
    fill: "#9597AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80086 0.185547C1.09991 0.185547 0.531128 0.754325 0.531128 1.45527C0.531128 2.15622 1.09991 2.7369 1.80086 2.7369C2.50181 2.7369 3.07058 2.15622 3.07058 1.45527C3.07014 0.754325 2.50136 0.185547 1.80086 0.185547V0.185547Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.88e36203b61dd371b095c1fda6f1477e.svg";
export { ForwardRef as ReactComponent };